import { isArray, merge } from "lodash";
import { Language } from "../../config/language";
import { cloneDeep, get, set } from "../../utils";

/**
 * 每项的加工，用于多语言处理
 * @param {*} colItem
 * @param {*} props
 * @returns
 */
export const colItemProcess = function (colItem, props) {
  const controlList = get(colItem, "controlList", []);
  let result = [];
  const baseParam = cloneDeep(get(controlList, "[0]", {}));
  const languageConfig = Language.config;
  const keys = Object.keys(languageConfig);
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    const package_ = languageConfig[key];
    const abbreviation = get(package_, "abbreviation", "");
    const id =
      get(baseParam, "controlItemParam.id", "") + (i === 0 ? "" : `_i${i}`);
    const param = {
      ...baseParam,
      env: abbreviation,
      index: i,
      controlItemParam: {
        ...get(baseParam, "controlItemParam", {}),
        id,
      },
    };
    result.push(param);
  }
  let resultParam = { ...colItem, controlList: result };
  return resultParam;
};

/**
 * 创建完整结构的form表单参数
 * @param {*} formItems
 */
const formSetValue = (formItems) => {
  let form = [];
  //创建form的结构
  let setValue = (coordinate, formItem) => {
    coordinate = coordinate.split("-");
    if (coordinate && coordinate.length < 3) {
      console.error(
        "坐标参数coordinate，必须是 0-0-0 或 0-0-0-0 格式，不能小于三段"
      );
      return;
    }
    let route = [];
    coordinate.map((item, idx) => {
      idx == 0 ? route.push(`[${item}]`) : ""; //form
      idx == 1 ? route.push(`row[${item}]`) : ""; //行
      idx == 2 ? route.push(`col[${item}]`) : ""; //列
      idx == 3 ? route.push(`controlList[${item}]`) : ""; //控件
    });
    if (coordinate.length == 3) route[3] = `controlList[0]`; //如果没有设置控件项坐标，默认为第一个
    route = route.join(".");
    set(form, route, formItem);
  };

  let coordinateNullItems = []; //无坐标的项
  //无坐标的情况下,要注入的值
  let coordinateNullSetValue = (list) => {
    let param = {
      row: [
        {
          col: [],
        },
      ],
    };
    isArray(list) &&
      list.map((item) => {
        param.row[0].col.push({ controlList: [item] });
      });
    return param;
  };

  formItems.map((item) => {
    let coordinate = get(item, "coordinate");
    if (coordinate) {
      if (isArray(coordinate)) {
        coordinate.map((cItem) => {
          setValue(cItem, item);
        });
      } else {
        setValue(coordinate, item);
      }
    } else {
      coordinateNullItems.push(item);
    }
  });

  //无坐标项解析
  if (coordinateNullItems.length > 0) {
    set(
      form,
      `[${form.length - 1 < 0 ? 0 : form.length - 1}]`,
      coordinateNullSetValue(coordinateNullItems)
    );
  }
  return form;
};

/**
 * 给form结构中的各层级赋值参数
 * @param {*} form 创建好的form参数结构
 * @param {*} formItemParams
 */
const formSetParam = (form, formItemParams) => {
  let formParam = [];

  let setValue = (coordinate, formItemParam) => {
    coordinate = coordinate.split("-");
    if (!coordinate) {
      console.error("必须包含coordinate参数");
      return;
    }
    let route = [];
    coordinate.map((item, idx) => {
      idx == 0 ? route.push(`[${item}]`) : ""; //form
      idx == 1 ? route.push(`row[${item}]`) : ""; //行
      idx == 2 ? route.push(`col[${item}]`) : ""; //列
    });
    route = route.join(".");
    set(formParam, route, formItemParam);
    form = merge(form, formParam);
  };

  if (formItemParams && !isArray(formItemParams)) {
    console.error("formItemParamList参数组必须是数组格式");
    return form;
  }
  if (isArray(formItemParams)) {
    formItemParams.map((item) => {
      let coordinate = get(item, "coordinate");
      let param = get(item, "param", {});
      if (coordinate) {
        if (isArray(coordinate)) {
          coordinate.map((cItem) => {
            setValue(cItem, param);
          });
        } else {
          setValue(coordinate, param);
        }
      }
    });
  }
  return form;
};

/**
 * 处理formItems，将参数处理为原本form所需的格式
 */

export const formItemsFactory = (formParam) => {
  let formItems = get(formParam, "formItemList");
  let formItemParams = get(formParam, "formItemParamList");
  let form = formSetValue(formItems); //创建form参数结构
  form = formSetParam(form, formItemParams); //赋值参数
  set(formParam, "form", form);
  return formParam;
};



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxDynamicForm/tools.js